
import React from 'react';
import AdminPage from '@/components/admin/AdminPage';

const Admin = () => {
  return (
    <div className="min-h-screen bg-slate-100 dark:bg-gray-950">
      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-r from-blue-200/20 to-purple-200/20 dark:from-blue-900/20 dark:to-purple-900/20"></div>
      <AdminPage />
    </div>
  );
};

export default React.memo(Admin);
